/**
 * DetailButtonsContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled detail buttons container.
 */
const DetailButtonsContainer = styled.div<{ hasMargin?: boolean }>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${(props) => (props.hasMargin ? 24 * Screen.widthRatio : 0)}px;
`;

export default DetailButtonsContainer;
